import { isMobile, toggleElementClass } from "../../scripts/helpers";

class Header {
  constructor() {
    if(document.querySelector('header') != null && document.querySelector('header') != undefined) {
      var isPageComparison = document.querySelector('body').classList.contains('page--comparison');
      var isPagePlanSteps = document.querySelector('body').classList.contains('page--plan-steps');
  
      if(!isPagePlanSteps) {
        if(!isPageComparison) {
          this.scrollMap();
      
          if(isMobile()) {
            this.bindEvents();
          }
        } else {
          this.scrollMapComparison();
        }
      }
    }
  }

  scrollMapComparison() {
    var menuOverlap = document.querySelector('.comparison-section__results--overlap');
    var sectionReference = document.querySelector('.comparison-section__results');
    var bodyRect = document.body.getBoundingClientRect();
    var elemRect = sectionReference.getBoundingClientRect();
    var overlapOffset = elemRect.top - bodyRect.top;

    window.onscroll = function() {
      fixMenu(window.pageYOffset);
    };

    function fixMenu(st) {
      var calcTop;

      if(isMobile()) {
        calcTop = st - overlapOffset - 150;
        
        if(st > (overlapOffset + 300) && st < document.querySelector('.comparison-section__slider').offsetHeight) {
          menuOverlap.classList.add('comparison-section__results--active');
          // menuOverlap.style.top = `${calcTop}px`;
        } else {
          menuOverlap.removeAttribute('style');
          menuOverlap.classList.remove('comparison-section__results--active');
        }
      } else {
        // calcTop = (st - overlapOffset) + 85;

        if(st > (overlapOffset + 100) && st < (document.querySelector('.comparison-section__slider').offsetHeight + 110) && document.querySelector('.comparison-section__slider').offsetHeight > 750) {
          menuOverlap.classList.add('comparison-section__results--active');
          // menuOverlap.style.top = `${calcTop}px`;
        } else {
          menuOverlap.removeAttribute('style');
          menuOverlap.classList.remove('comparison-section__results--active');
        }
      }
    }
  }

  scrollMap() {
    let didScroll;
    let lastScrollTop = 0;
    let delta = 5;
    let navbarHeight = document.querySelector('header .header__wrapper').offsetHeight;
    let header = document.querySelector('header');

    window.onscroll = function() {
      didScroll = true;
    };

    setInterval(function() {
      if (didScroll) {
        let st = window.pageYOffset;

        if(isMobile()) {
          hasScrolled(st);
        }

        didScroll = false;
      }
    }, 250);

    function hasScrolled(st) {    
      if (Math.abs(lastScrollTop  -  st) <= delta) return;
      st > lastScrollTop && st > navbarHeight ? header.classList.add('fixed') : header.classList.remove('fixed');
      lastScrollTop = st;
    }
  }

  bindEvents() {
    let iconMenu = document.querySelector('.header__icon-menu');
    let associatedMenuLink = document.querySelector('.header__associatemenu-link');
    let associatedMenu = document.querySelector('.header__subscriber-menu');
    let associatedMenuBenefits = document.querySelector('.header__menu--benefits');
    let openAssociatedMenuBenefits = document.querySelector('.open-benefits');
    let closeAssociatedMenuBenefits = document.querySelector('.close__benefits');
    let header = document.querySelector('header');
    let body = document.querySelector('body');
    var linksInsideSubmenuTitle = document.querySelectorAll('.header .menu-list .menu-item__title a');

    if(linksInsideSubmenuTitle.length > 0) {
      linksInsideSubmenuTitle.forEach(element => {
        element.addEventListener('click', function(e) {
          e.preventDefault();

          element.parentNode.click();
        });
      });
    }

    iconMenu.addEventListener('click', function() {
      toggleElementClass(header, 'header--open-menu');
      toggleElementClass(body, 'overflowed');
    });
    
    associatedMenuLink.addEventListener('click', function() {
      toggleElementClass(associatedMenu, 'header__subscriber-menu--active');
      toggleElementClass(associatedMenuLink, 'close');
      toggleElementClass(body, 'overflowed');
      toggleElementClass(iconMenu, 'hidden');
    });

    openAssociatedMenuBenefits.addEventListener('click', function() {
      toggleElementClass(associatedMenuBenefits, 'active');
    });

    closeAssociatedMenuBenefits.addEventListener('click', function() {
      toggleElementClass(associatedMenuBenefits, 'active');
    });

    if(isMobile()) {
      window.location.search.includes('opened-benefit-menu') && openBenefitMenu();
  
      function openBenefitMenu() {
        toggleElementClass(associatedMenu, 'header__subscriber-menu--active');
        toggleElementClass(associatedMenuLink, 'close');
        toggleElementClass(body, 'overflowed');
        toggleElementClass(iconMenu, 'hidden');
        toggleElementClass(associatedMenuBenefits, 'active');
      }

      window.location.search.includes('opened-user-menu') && openUserMenu();
  
      function openUserMenu() {
        toggleElementClass(associatedMenu, 'header__subscriber-menu--active');
        toggleElementClass(associatedMenuLink, 'close');
        toggleElementClass(body, 'overflowed');
        toggleElementClass(iconMenu, 'hidden');
      }
    }
  }
};

const header = new Header();